import { importClass } from "../../utilities/dynamicImportsUtility";

export default class PersonalizedOffer extends HTMLElement {
  private readonly initializedAttribute = "is-initialized";
  public constructor() {
    super();
  }

  public connectedCallback() {
    console.debug("Personalized Offer");
    if (document.readyState === "loading") {
      window.addEventListener("DOMContentLoaded", () => this.initialize());
    } else {
      this.initialize();
    }
  }

  private async initialize() {
    this.setAttribute(this.initializedAttribute, "true");
    importClass(
      () =>
        import(
          /* webpackChunkName: "personalizedOfferController" */ "./personalizedOfferController"
        ),
      true,
      [this]
    );
  }
}

customElements.define("personalized-offer", PersonalizedOffer);
